<template>
  <div class="topWrapper">
    <top-box class="total"
      text="전체"
      :data="topData.total">
    </top-box><!--
    --><top-box class="doing"
      text="진행"
      :data="topData.cnt_2">
    </top-box><!--
    --><top-box class="hold"
      text="홀딩"
      :data="topData.cnt_3">
    </top-box><!--
    --><top-box class="complete"
      text="완료"
      :data="topData.cnt_4">
    </top-box>
  </div>
</template>
    
<script>
  import { mapState } from 'vuex'

  import TopBox from '@/components/dashboard/TopBox'
  export default {
    name: 'dashboard',
    components: {
      TopBox
    },
    computed: {
      ...mapState([
        'dashboardData'
      ]),
      topData () {
        return this.dashboardData.top
      }
    }
  }
</script>

<style scoped>
  .topWrapper {
    width: 100%;
    margin-bottom: 5px;
  }
  .total {
    background-color: #8bc34a;
  }
  .doing {
    background-color: #03a9f4;
  }
  .hold {
    background-color: #e84e40;
  }
  .complete {
    background-color: #666;
  }
</style>


// WEBPACK FOOTER //
// Dashboard.vue?b9254d58